import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Observable } from 'rxjs';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ACTIVE_PAGE_CONFIG } from '@app/pages/cmms/configs/active-page.config';
import { CmmsPages } from '@app/pages/cmms/state/cmms.reducer';
import { AuRightSidebarService } from '@app/core/services/au-right-sidebar.service';
import {
	IncidentDetectedStatus,
	IResultData,
} from '@app/pages/cmms/interfaces/incident-detection.interfaces';
import { ICmmsAssignee } from '@app/pages/cmms/interfaces/assignee.interface';
import { MatTooltipModule } from '@angular/material/tooltip';
import { IncidentsService } from '@app/pages/cmms/services/incidents.service';
import { IconSnackBarService } from '@app/core/services/icon-snack-bar.service';
import { CmmsEntityNameComponent } from '@app/pages/cmms/components/shared-form-group-controls/cmms-entity-name/cmms-entity-name.component';
import { CmmsDescriptionComponent } from '@app/pages/cmms/components/shared-form-group-controls/cmms-description/cmms-description.component';
import { CmmsPriorityLevelComponent } from '@app/pages/cmms/components/shared-form-group-controls/cmms-priorirty-level/cmms-priority-level.component';
import { CmmsEntityCategoryComponent } from '@app/pages/cmms/components/shared-form-group-controls/cmms-entity-category/cmms-entity-category.component';
import { CmmsAssigeeAndApproverComponent } from '@app/pages/cmms/components/shared-form-group-controls/cmms-assignees-and-approver/cmms-assigee-and-approver.component';

@Component({
	selector: 'file-incident-item',
	imports: [
		CommonModule,
		MatIconModule,
		MatButtonModule,
		MatTooltipModule,
		CmmsEntityNameComponent,
		CmmsDescriptionComponent,
		CmmsPriorityLevelComponent,
		CmmsEntityCategoryComponent,
		CmmsAssigeeAndApproverComponent,
	],
	templateUrl: './file-incident-item.component.html',
	styleUrls: ['./file-incident-item.component.scss'],
})
export class FileIncidentItemComponent {
	private readonly sidebarService = inject(AuRightSidebarService);
	private readonly incidentService = inject(IncidentsService);
	private readonly notify = inject(IconSnackBarService);

	@Input() incidentItem: IResultData;
	@Output() changeStatus = new EventEmitter<IResultData>();
	isFullscreen$: Observable<boolean>;

	setIncidentStatus(status: IncidentDetectedStatus) {
		this.changeStatus.emit({ ...this.incidentItem, status });
	}

	changeData(property: string, incidentData: { [key: string]: any }) {
		this.incidentItem[property] = incidentData[property];
	}

	changeAssigneeData(property: string, incidentData: ICmmsAssignee) {
		this.incidentItem[property] = incidentData;
	}

	viewSelectedEntity() {
		this.setHomeComponent();
		const selectedPage = ACTIVE_PAGE_CONFIG[CmmsPages.editIncident];
		this.incidentService
			.getIncidentByPk(this.incidentItem.incident.pk)
			.subscribe(incident => {
				if (!incident) {
					this.notify.error('Incident not found');
					this.setIncidentStatus('DELETED');
					return;
				}
				this.sidebarService.addNewItemToNavigationAndOpen({
					component: selectedPage.createComponent,
					sidebarConfig: {
						...selectedPage.sidebarConfig,
						title: {
							text: selectedPage.sidebarConfig.title.text,
							endfix: incident.id,
						},
					},
					data: {
						componentType: CmmsPages.editIncident,
						entityObject: this.incidentItem.incident,
					},
				});
			});
	}

	setHomeComponent() {
		if (!this.sidebarService.isHistoryExisting) {
			const currentPage = ACTIVE_PAGE_CONFIG[CmmsPages.fileDetector];
			this.sidebarService.setHomeComponent({
				component: currentPage.createComponent,
				sidebarConfig: {
					...currentPage.sidebarConfig,
					title: {
						text: currentPage.sidebarConfig.title.text,
					},
				},
				data: {
					componentType: CmmsPages.fileDetector,
				},
			});
		}
	}
}
